import { ENTER_KEY } from '../constants/commonConstants';

export const onEnterKey = <T>(e: React.KeyboardEvent<T>, onClick: React.MouseEventHandler<T> | undefined) => {
  const { key } = e;
  if (key !== ENTER_KEY) return;
  onClick?.(e as any);
};
